import { UserRoleViewModel } from '.';
import { endpoint,mappable } from '../decorators';
import { BaseViewModel } from './base-view-model';

@endpoint('role')
export class RoleViewModel extends BaseViewModel {
  public RoleName: string = '';
  public Description: string = '';

  @mappable('UserRoleViewModel')
  public UserRoles: UserRoleViewModel[] = [];
}
